import React, { useContext, useEffect } from 'react';
import { buriedPoint } from '@home/utils/buriedPoint';
import { LayoutContext } from '@/pages/benchmark/state/LayoutContext';
import { getLogTypeId } from '@/pages/benchmark/utils/utils';
import LowCodeTemplateWrapper from '@/pages/intelligence/v3/pages/LowCodeTemplateWrapper';

const IAABenchmarks: React.FC = () => {
  const { frameType, currentMenu } = useContext(LayoutContext);

  // Benchmark 侧页面打点
  useEffect(() => {
    if (!currentMenu) {
      return;
    }
    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: '801301',
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: '/IAABenchmarks',
      uidType: '', // 基准打点不包含uidType
      typeId: getLogTypeId(frameType),
    };
    buriedPoint(logObj);
  }, [currentMenu, frameType]);

  return <LowCodeTemplateWrapper/>;
};

export default IAABenchmarks;
